import { get } from 'lodash/fp';

import createReducer from '../utils/createReducer';
import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from '../constants/actionTypes';
import { INVITE_OTHERS } from '../constants/apiTypes';

const initialState = {
  errors: [],
  isSubmitting: false
};

const inviteReducer = createReducer(initialState, {
  [API_CALL_REQUEST]: (state, action) =>
    action.api === INVITE_OTHERS
      ? {
          errors: [],
          isSubmitting: true
        }
      : undefined,

  [API_CALL_FAILURE]: (state, action) =>
    action.api === INVITE_OTHERS
      ? {
          errors: get('errors.messages', action) || state.errors,
          isSubmitting: false
        }
      : undefined,

  [API_CALL_SUCCESS]: (state, action) =>
    action.api === INVITE_OTHERS
      ? {
          isSubmitting: false
        }
      : undefined
});

export default inviteReducer;
